import { useClerk, useUser } from '@clerk/clerk-react';
import { useCallback } from 'react';

/**
 * The owner's 240 account, where their name and photo live (R1). `open` shows Clerk's own
 * account dialog. Clerk gives that dialog no close callback, so `version` follows the Clerk
 * user instead: it moves whenever the user is saved there, and the profile page reloads on it,
 * which makes the Worker sync the new name or photo.
 */
export function useClerkAccount(): { open(): void; version: number } {
  const clerk = useClerk();
  const { user } = useUser();
  const open = useCallback(() => clerk.openUserProfile(), [clerk]);
  return { open, version: user?.updatedAt?.getTime() ?? 0 };
}
